/**
 * The customer payload of the composer is keyed under the customer root (kundeQueries.messageData):
 * it is the customer record, and whoever changes a customer must not have to know that this screen
 * caches one too.
 *
 * What stays here is the appointment payload - customer, project and appointment in one response,
 * keyed by terminId. It belongs to no single object, which is why kundeInvalidationKeys names this
 * root explicitly.
 */
export const sendNachrichtKeys = {
    all: ["sendNachricht"],
    appointment: (terminId) => [...sendNachrichtKeys.all, "appointment", terminId],
};
